import { useEffect, useState } from "react";
import qrcode from "qrcode-generator";
import { useParams } from "react-router-dom";

const PageQR: React.FC = ({ desc }) => {
    const [qrCode, setQrCode] = useState<string | null>(null)

    const params = useParams()
    useEffect(() => {
        // page qr code
        const qr = qrcode(0, 'L')
        qr.addData(document.location.href)
        qr.make()
        setQrCode(qr.createDataURL())
    }, [params])

    return (
    <div className="qr-code-container flex flex-col items-center">
        {qrCode && <img 
            style={{ imageRendering: 'pixelated' }} 
            src={qrCode} 
            width="256" 
            height="256" 
            className="border-4 border-blue-500 dark:border-blue-400 rounded-xl p-2 bg-white" 
            alt="QR Code for sharing this book"
        />}
        <p className="pt-2 text-sm text-gray-600 dark:text-gray-400 text-center">
            {desc}
        </p>
    </div>)
}

export default PageQR